import {Row, Col} from "reactstrap";
import {useUser} from "../../contexts/AuthContext";
import BenchmarkItem from "./BenchmarkItem";

const BenchmarksCollection = (props: any) => {
  const {user} = useUser();

  const timezoneOffsetMinutes: number = user.settings.timezoneOffsetMinutes;

  if (props === undefined || !props.items || !props.items.length) {
    return (
      <>
        <h4>No results</h4>
      </>
    );
  }

  // rows are ordered by avg fps desc
  // render all bars for all items
  // relative to the MAX fps of the 1st item
  let scaleFactor: number = props.items[0].MaxFps;
  //let scaleFactor: number = maxMaxFps;

  let items: any[] = [];

  let counter: number = 1;
  for (const item of props.items) {
    items.push(
      <BenchmarkItem
        {...item}
        index={counter}
        scaleFactor={scaleFactor}
        key={`i-${counter}`}
        rank={counter}
        timezoneOffsetMinutes={timezoneOffsetMinutes}
        {...props}
      />
    );
    counter += 1;
  }

  return (
    <>
      <Row>
        <Col lg="12" md="12">
          {items}
        </Col>
      </Row>
    </>
  );
};

export default BenchmarksCollection;
